import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVolumeUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"volume-up"} maskId="square-filled-radius-0-stroke-1-IconVolumeUp"><path d="M13 2.88428V21.1157L5.86611 17H1V6.99998H5.86611L13 2.88428Z" fill="currentColor"/><path d="M19.5 11.5V8H18.5V11.5H15V12.5H18.5V16H19.5V12.5H23V11.5H19.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVolumeUp;
